/**
 * Promise rejection severity classification strategy
 */

import type { SeverityStrategy, ErrorContext } from './SeverityStrategy.js';
import type { Severity } from '../../types.js';

export class PromiseRejectionSeverity implements SeverityStrategy {
  canHandle(context: ErrorContext): boolean {
    return context.type === 'promise';
  }

  classify(_context: ErrorContext): Severity {
    // Promise rejections are generally critical as they indicate unhandled async errors
    // Most unhandled promise rejections indicate serious bugs
    return 'critical';
  }
}

